import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { PortalStorageService } from './../../services/storage/portal-storage.service';
import { setBearerHeaders } from './http-helper';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private storageService: PortalStorageService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.storageService.getToken();
        const isLoggedIn = token && token.accessToken;
        const isApiUrl = request.url.startsWith(environment.apiUrl);
        if (isLoggedIn && isApiUrl) {
            request = request.clone({
                setHeaders: setBearerHeaders(token.accessToken),
            });
        }

        return next.handle(request);
    }
}
